<template>
  <div
    class="img-button-wrap"
    :class="{disabled:isDisabled}"
    @click="$_onTo"
  >
    <div
      class="img-button"
      :class="{
        blueGradient,
        row:isRow,
        small:isSmall,
        'disable-pointer': isDisablePointer,
        'disable-hover': isDisableHover,
      }"
      :style="{
        'justify-content': justifyContent,
        'padding': padding
      }"
      @click="onClick()"
    >
      <LvFlexBox
        v-if="leadingImage"
        justifyContent="start"
        class="img-button__image-wrap mb-20"
      >
        <img
          :src="leadingImage"
          class="img-button__image"
        />
      </LvFlexBox>
      <i
        v-if="isDisabled"
        class="img-button__icon"
        :class="disabledIcon"
      />
      <i
        v-else
        class="img-button__icon"
        :class="leadingIcon"
      />
      <p
        v-if="textLabel"
        :class="{
          bigText,
          smallText,
          'multiline-ellipsis':multilineEllipsis,
        }"
        class="img-button__text"
      >
        {{ $t(textLabel) }}
      </p>
      <p
        v-if="description"
        :class="{
          bigText,
          smallText,
          'multiline-ellipsis':multilineEllipsis,
        }"
        class="img-button__text description mt-20"
      >
        {{ $t(description) }}
      </p>
      <LvFlexBox
        v-if="links && links.length > 0"
        :style="{'z-index': 3, width: '100%'}"
        justifyContent="space-evenly"
        class="img-button__links-wrap"
      >
        <WsButton001
          v-for="(link,linkIndex) in links"
          :key="linkIndex"
          mediumButton
          class="mb-8"
          @click="$_onClickLink(link.url, link.query)"
        >
          <LvText h3 bold white>{{ $t(link.text) }}</LvText>
        </WsButton001>
      </LvFlexBox>
      <div
        class="img-button__bg image"
        :style="{backgroundImage: `url(${image})`}"
      />
      <div class="img-button__bg blue" />
      <div class="img-button__bg black" />
    </div>
    <div
      v-if="number && !isDisabled"
      class="num"
    >
      {{ C_number }}
    </div>
    <div
      v-if="isDisabled && disabledText"
      class="img-button-wrap__disabled-wrap"
      :class="{small:isSmall}"
    >
      <p class="img-button-wrap__disabled-text">
        {{ $t(disabledText) }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "ImgButton",
  props: {
    to: {
      type: String,
      default: "",
    },
    image: {
      type: String,
      default: "",
    },
    textLabel: {
      type: String,
      default: "",
    },
    leadingIcon: {
      type: String,
      default: "",
    },
    smallText: {
      type: Boolean,
      default: false,
    },
    blueGradient: {
      type: Boolean,
      default: false,
    },
    number: {
      type: Number,
      default: 0,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    disabledText: {
      type: String,
      default: "",
    },
    disabledIcon: {
      type: String,
      default: "",
    },
    isRow: {
      type: Boolean,
      default: false,
    },
    isSmall: {
      type: Boolean,
      default: false,
    },
    multilineEllipsis: {
      type: Boolean,
      default: false,
    },
    links: {
      type: Array,
      default() {
        return [];
      },
    },
    isDisablePointer: {
      type: Boolean,
      default: false,
    },
    isDisableHover: {
      type: Boolean,
      default: false,
    },
    justifyContent: {
      type: String,
    },
    bigText: {
      type: Boolean,
      default: false,
    },
    leadingImage: {
      type: String,
    },
    description: {
      type: String,
    },
    padding: {
      type: String,
    }
  },
  computed: {
    C_number() {
      if (!this.number) return;
      let num;
      if (this.number > 100) {
        num = 99 + "+";
      } else {
        num = this.number;
      }
      return num;
    },
  },
  methods: {
    $_onTo() {
      if (this.isDisabled || !this.to) return;
      this.$router.push(this.to);
    },
    onClick() {
      if (this.isDisabled) return;
      this.$emit("click");
    },
    $_onClickLink(url, query) {
      if (!url) return;
      this.$router.push({
        path: url,
        query,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/img-button";
</style>